import { AsyncPipe, DatePipe, NgTemplateOutlet } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { DepotTransferPageBase } from '@zero/self-service/feature-depot-transfer/base';
import { LoadingIndicatorDirective } from '@zero/shared/ui-directives';
import { ButtonComponent } from '@zero/shared/ui-web-design-system';

@Component({
  selector: 'self-service-depot-transfer',
  templateUrl: './portfolio-transfer.component.html',
  imports: [LoadingIndicatorDirective, FormsModule, NgTemplateOutlet, AsyncPipe, DatePipe, TranslocoPipe, ButtonComponent],
})
export class PortfolioTransferComponent extends DepotTransferPageBase implements OnInit {
  ngOnInit(): void {
    this.init();
  }
}
